import React, { useState } from "react";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, InputNumber, Select, Tag, Upload } from "antd";
import { formRules } from "utils/form";

function validateFile(file) {
  const isLargeFile = file?.size && file?.size >= 5 * 1024 * 1024;
  if (isLargeFile) {
    throw new Error(
      `${file.name} - Размер изображения не должен превышать 5 МБ.`
    );
  } else return true;
}

const ColorPicker = ({ value = [], onChange }) => {
  const [inputValue, setInputValue] = useState("");

  const handleAddColor = () => {
    if (inputValue && !value.includes(inputValue)) {
      const newValue = [...value, inputValue];
      onChange(newValue);
      setInputValue("");
    }
  };

  const handleRemoveColor = (color) => {
    const newValue = value.filter((item) => item !== color);
    onChange(newValue);
  };

  return (
    <div className="flex gap-x-2">
      <div className="flex flex-wrap gap-2">
        {value.map((color) => (
          <Tag className="flex items-center gap-x-1" color={color}>
            {color}
            <span
              className="cursor-pointer"
              onClick={() => handleRemoveColor(color)}
            >
              ✕
            </span>
          </Tag>
        ))}
      </div>
      <Input
        className="min-w-14 w-14"
        type="color"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <Button onClick={handleAddColor}>Добавить</Button>
    </div>
  );
};

export function FormComponent(props) {
  const onChange = (fileList) => {
    const newFileList = [];
    for (let i = 0; i < fileList.length; i++) {
      if (validateFile(fileList[i])) {
        newFileList.push(fileList[i]);
      }
    }
    props.setFileList({ photos: newFileList });
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  return (
    <Form form={props.form} layout="vertical" onFinish={props.onFinish}>
      <div className="grid grid-cols-2 gap-x-3">
        <Form.Item label="Категория" name="category_id" rules={formRules}>
          <Select
            placeholder="Категория"
            options={
              props.categories.map((category) => ({
                value: category.id,
                label: category.name,
              })) || []
            }
          />
        </Form.Item>
        <Form.Item label="Название" name="name" rules={formRules}>
          <Input placeholder="Название продукта..." />
        </Form.Item>
        <Form.Item label="Цена" name="price" rules={formRules}>
          <InputNumber placeholder="Цена" style={{ width: "100%" }} min={0} />
        </Form.Item>
        <Form.Item label="Описание" name="description" rules={formRules}>
          <Input placeholder="Описание..." />
        </Form.Item>
      </div>
      <Form.Item label="Размеры" name="sizes">
        <Form.List name="sizes">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <div key={key} className="grid grid-cols-12 gap-x-2">
                  <Form.Item
                    className="col-span-2"
                    {...restField}
                    name={[name, "size"]}
                  >
                    <Input placeholder="Размер..." />
                  </Form.Item>
                  <Form.Item
                    className="col-span-9"
                    {...restField}
                    name={[name, "colors"]}
                  >
                    <ColorPicker />
                  </Form.Item>
                  <Button
                    className="ml-auto"
                    danger
                    onClick={() => remove(name)}
                    icon={<DeleteOutlined />}
                  />
                </div>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  icon={<PlusOutlined />}
                >
                  Добавить размер
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form.Item>

      <Form.Item label="Фотографии" name="photos" rules={formRules}>
        <Upload
          accept="image/png, image/jpeg, image/svg, image/webp"
          listType="picture-card"
          fileList={props.fileList?.photos || []}
          onPreview={onPreview}
          showUploadList={true}
          multiple
          customRequest={({ onSuccess }) => {
            onSuccess("ok");
          }}
          onChange={(e) => onChange(e.fileList)}
        >
          {props.fileList?.photos.length < 1 && "+ Загрузить"}
        </Upload>
      </Form.Item>

      <Form.Item className="flex justify-end mb-0">
        <Button
          type="primary"
          size="large"
          htmlType="submit"
          loading={props.btnLoading}
        >
          {props.type === "create" ? "Создать" : "Обновить"}
        </Button>
      </Form.Item>
    </Form>
  );
}
